/** Modal form field styles */
export const labelClass =
  'block text-xs font-semibold uppercase tracking-wider text-text-dimmed mb-1.5'

export const inputClass =
  'w-full rounded-lg border border-border-main bg-neutral-shadow px-3 py-2 text-sm text-text-primary placeholder-text-dimmed focus:border-violet-500 focus:outline-none'

/** Shared nav-bar styles (search input + add button) used across Control Center pages */
export const navInputCls =
  'h-8 rounded-md border border-border-main bg-neutral-shadow px-3 text-[13px] text-text-secondary placeholder-text-tertiary focus:border-border-shadow focus:outline-none'

export const addBtnCls =
  'flex h-8 shrink-0 items-center gap-1.5 rounded-md bg-[#fddb54] px-4 text-sm font-medium text-[#191919] transition hover:bg-[#e6c94c]'

/** Nav-bar select (status / severity filters) */
export const navSelectCls =
  'h-8 rounded-md border border-border-main bg-neutral-shadow px-3 text-[13px] text-text-secondary focus:outline-none'
